import { Action } from "redux";
import {
  CreateContractByClientRequest,
  UpdateContractByClientRequest,
  OpenCreateFormContractByClientRequest,
  ApproveContractByClientRequest,
} from "../request/contract_request";
import {
  CreateContractByClientResponse,
  UpdateContractByClientResponse,
  OpenCreateFormContractByClientResponse,
} from "../response/contract_response";

export enum ClientContractActionType {
  REQUEST_CREATE_CONTRACT = "CLIENT_CONTRACT_REQUEST_CREATE_CONTRACT",
  CALLBACK_CREATE_CONTRACT = "CLIENT_CONTRACT_CALLBACK_CREATE_CONTRACT",
  REQUEST_UPDATE_CONTRACT = "CLIENT_CONTRACT_REQUEST_UPDATE_CONTRACT",
  CALLBACK_UPDATE_CONTRACT = "CLIENT_CONTRACT_CALLBACK_UPDATE_CONTRACT",
  REQUEST_OPENCREATEFORM_CONTRACT = "CLIENT_CONTRACT_REQUEST_OPENCREATEFORM_CONTRACT",
  CALLBACK_OPENCREATEFORM_CONTRACT = "CLIENT_CONTRACT_CALLBACK_OPENCREATEFORM_CONTRACT",

  REQUEST_APPROVE_CONTRACT = "CLIENT_CONTRACT_REQUEST_APPROVE_CONTRACT",
  CALLBACK_APPROVE_CONTRACT = "CLIENT_CONTRACT_CALLBACK_APPROVE_CONTRACT",
}

export interface IRequestCreateContractAction extends Action {
  type: ClientContractActionType.REQUEST_CREATE_CONTRACT;
  item: CreateContractByClientRequest;
}

export interface ICallbackCreateContractAction extends Action {
  type: ClientContractActionType.CALLBACK_CREATE_CONTRACT;
  isSuccess: boolean;
  item?: CreateContractByClientResponse;
  error?: any;
}

export interface IRequestUpdateContractAction extends Action {
  type: ClientContractActionType.REQUEST_UPDATE_CONTRACT;
  item: UpdateContractByClientRequest;
}

export interface ICallbackUpdateContractAction extends Action {
  type: ClientContractActionType.CALLBACK_UPDATE_CONTRACT;
  isSuccess: boolean;
  item?: UpdateContractByClientResponse;
  error?: any;
}

export interface IRequestOpenCreateFormContractAction extends Action {
  type: ClientContractActionType.REQUEST_OPENCREATEFORM_CONTRACT;
  item: OpenCreateFormContractByClientRequest;
}

export interface ICallbackOpenCreateFormContractAction extends Action {
  type: ClientContractActionType.CALLBACK_OPENCREATEFORM_CONTRACT;
  isSuccess: boolean;
  item?: OpenCreateFormContractByClientResponse;
  error?: any;
}

export interface IRequestApproveContractAction extends Action {
  type: ClientContractActionType.REQUEST_APPROVE_CONTRACT;
  item: ApproveContractByClientRequest;
}

export interface ICallbackApproveContractAction extends Action {
  type: ClientContractActionType.CALLBACK_APPROVE_CONTRACT;
  isSuccess: boolean;
  error?: any;
}

export type ClientContractAction =
  | IRequestCreateContractAction
  | ICallbackCreateContractAction
  | IRequestUpdateContractAction
  | ICallbackUpdateContractAction
  | IRequestOpenCreateFormContractAction
  | ICallbackOpenCreateFormContractAction
  | IRequestApproveContractAction
  | ICallbackApproveContractAction;

export interface IClientContractActionCreator {
  requestCreateContractAction(
    item: CreateContractByClientRequest
  ): IRequestCreateContractAction;

  callbackCreateContractAction(
    isSuccess: boolean,
    item?: CreateContractByClientResponse,
    error?: any
  ): ICallbackCreateContractAction;

  requestUpdateContractAction(
    item: UpdateContractByClientRequest
  ): IRequestUpdateContractAction;

  callbackUpdateContractAction(
    isSuccess: boolean,
    item?: UpdateContractByClientResponse,
    error?: any
  ): ICallbackUpdateContractAction;

  requestOpenCreateFormContractAction(
    item: OpenCreateFormContractByClientRequest
  ): IRequestOpenCreateFormContractAction;

  callbackOpenCreateFormContractAction(
    isSuccess: boolean,
    item?: OpenCreateFormContractByClientResponse,
    error?: any
  ): ICallbackOpenCreateFormContractAction;

  requestApproveContractAction(
    item: ApproveContractByClientRequest
  ): IRequestApproveContractAction;

  callbackApproveContractAction(
    isSuccess: boolean,
    error?: any
  ): ICallbackApproveContractAction;
}

class ActionCreator implements IClientContractActionCreator {
  public requestCreateContractAction = (
    item: CreateContractByClientRequest
  ): IRequestCreateContractAction => {
    return {
      type: ClientContractActionType.REQUEST_CREATE_CONTRACT,
      item,
    };
  };

  public callbackCreateContractAction = (
    isSuccess: boolean,
    item?: CreateContractByClientResponse,
    error?: any
  ): ICallbackCreateContractAction => {
    return {
      type: ClientContractActionType.CALLBACK_CREATE_CONTRACT,
      isSuccess,
      item,
      error,
    };
  };

  public requestUpdateContractAction = (
    item: UpdateContractByClientRequest
  ): IRequestUpdateContractAction => {
    return {
      type: ClientContractActionType.REQUEST_UPDATE_CONTRACT,
      item,
    };
  };

  public callbackUpdateContractAction = (
    isSuccess: boolean,
    item?: UpdateContractByClientResponse,
    error?: any
  ): ICallbackUpdateContractAction => {
    return {
      type: ClientContractActionType.CALLBACK_UPDATE_CONTRACT,
      isSuccess,
      item,
      error,
    };
  };

  public requestOpenCreateFormContractAction = (
    item: OpenCreateFormContractByClientRequest
  ): IRequestOpenCreateFormContractAction => {
    return {
      type: ClientContractActionType.REQUEST_OPENCREATEFORM_CONTRACT,
      item,
    };
  };

  public callbackOpenCreateFormContractAction = (
    isSuccess: boolean,
    item?: OpenCreateFormContractByClientResponse,
    error?: any
  ): ICallbackOpenCreateFormContractAction => {
    return {
      type: ClientContractActionType.CALLBACK_OPENCREATEFORM_CONTRACT,
      isSuccess,
      item,
      error,
    };
  };

  public requestApproveContractAction = (
    item: ApproveContractByClientRequest
  ): IRequestApproveContractAction => {
    return {
      type: ClientContractActionType.REQUEST_APPROVE_CONTRACT,
      item,
    };
  };

  public callbackApproveContractAction = (
    isSuccess: boolean,
    error?: any
  ): ICallbackApproveContractAction => {
    return {
      type: ClientContractActionType.CALLBACK_APPROVE_CONTRACT,
      isSuccess,
      error,
    };
  };
}

export const createClientContractDetailActionCreator =
  (): IClientContractActionCreator => {
    return new ActionCreator();
  };



// WEBPACK FOOTER //
// ./src/presentation/action/client_contract_action.ts